import {type AutocompleteRenderGroupParams} from '@mui/material/Autocomplete';
import {styled, type Theme} from '@mui/material/styles';

const GroupHeader = styled('div')`
  position: sticky;
  padding: 10px;
  color: ${({theme}: {theme: Theme}): string => theme.palette.text.primary};
  background-color: ${({theme}: {theme: Theme}): string =>
    theme.palette.background.paper};
`;

const GroupItems = styled('ul')`
  padding: 0;
`;

export function OptixAutocompleteRenderGroup({
  group,
  children,
  key,
}: AutocompleteRenderGroupParams): JSX.Element {
  return (
    <li key={key}>
      <GroupHeader>{group}</GroupHeader>
      <GroupItems>{children}</GroupItems>
    </li>
  );
}
